import { HMSRoomProvider } from "@100mslive/react-sdk";
import { HMSThemeProvider } from "@100mslive/react-ui";
import { ThemeProvider } from "@material-ui/core/styles";
import React from "react";
import "react-accessible-accordion/dist/fancy-example.css";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import "./assets/css/toastr.min.css";
import "./index.css";
import store, { persistor } from "./store/store";
import theme from "./theme";
import "toastr/build/toastr.css";
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById("root"));

const { 0: width, 1: height } = "16-9".split("-").map((el) => parseInt(el));
root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <HMSThemeProvider
                themeType={"light"}
                aspectRatio={{ width, height }}
            >
                <HMSRoomProvider>
                    <BrowserRouter>
                        <ThemeProvider theme={theme}>
                            <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_ID}>
                                <App />
                            </GoogleOAuthProvider>
                        </ThemeProvider>
                    </BrowserRouter>
                </HMSRoomProvider>
            </HMSThemeProvider>
        </PersistGate>
    </Provider>
);
